import type { ApiTerms } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchTerms(enabled = true) {
  return useQuery({
    queryKey: ['terms', 'current'],
    queryFn: async () => {
      const response = await fetch('/api/terms/current');
      if (!response.ok) {
        throw new Error('Failed to fetch terms');
      }
      const data: ApiTerms = await response.json();
      return data;
    },
    enabled, // 条件付きでフェッチを制御
  });
}
